import View from "../../../Nav/Js/views/FlashSalesView";
import components from "./components.js";
components.define("js-FlashSales", View);